import React from "react";
import styled from "styled-components";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import TelegramIcon from "@material-ui/icons/Telegram";
import Fade from "react-reveal/Fade";
import { ThemeSwitcher } from "../ThemeSwitcher";

function Footer() {
  const themesColor = React.useContext(ThemeSwitcher);

  return (
    <Fade left>
      <Container>
        <LeftContent>
          <h1>
          Contacts <img draggable={false} src="images/smartphone.png" alt="phone" />
          </h1>
          <h3>
          Any suggestions? Send me an email or social media 
          </h3>
          <p>
            Email:<a href="mailto:rinni499@gmail.com">rinni499@gmail.com</a>{" "}
          </p>
          <Links>
            <a className="git-icon icon" href="https://github.com/r33n99">
              <GitHubIcon />
            </a>
            <a className="linked-icon icon" href="https://www.linkedin.com/in/rinat-razhapov-8998a0209/">
              <LinkedInIcon />
            </a>
            <a className="telega-icon icon" href="https://t.me/r33n99">
              <TelegramIcon />
            </a>
          </Links>
          
        </LeftContent>
        
      </Container>
    </Fade>
  );
}

export default Footer;

const Container = styled.div`
  background: ${(themesColor) => themesColor.theme.back};
  margin: 0 auto;
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 768px) {
    font-size: 12px;
    margin-top: 25px;
  }
`;

const LeftContent = styled.div`
  color: ${(themesColor) => themesColor.theme.title};
  padding: 15px;
  letter-spacing: 2px;
  line-height: 2;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  a {
    color: ${(themesColor) => themesColor.theme.title};
    text-decoration: none;
    &:hover {
      color: ${(themesColors) => themesColors.theme.url};
    }
  }
  img {
    width: 50px;
  }
`;
const Links = styled.div`
  display: flex;
  margin: 0 auto 30px auto;
  a {
    margin: 10px 10px;
  }
  .icon {
    display: inline-block;
    fontsize: 44px;
    animation: float 5s ease-in-out infinite;
  }
 
  .linked-icon {
    animation-delay: 1s;
  }

  .telega-icon {
    animation-delay: 2s;
  }
  @keyframes float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-15px);
    }
    100% {
      transform: translateY(0);
    }
  }

`;
